
import {Options, Vue} from "vue-class-component";
import {responseToTicketRequest} from "@/services/TicketService";
import Swal from "sweetalert2";

@Options({
	props: {
		ticket: {
			default: {}
		}
	}
})
export default class Alert extends Vue {
	ticket: any
	frm: any = {
		message: { name: "Nachricht an Support", value: "" }
	}
	
	responseTicket() {
		const data: any = {
			id: this.ticket.id,
			text: this.frm.message.value
		}
		
		if ( this.frm.files.length > 0 ) {
			data.files = this.frm.files.value
		}
		
		responseToTicketRequest(data).then((res: any) => {
			if ( res.result ) {
				Swal.fire({
					title: "Erfolgreich",
					text: "Sie haben auf das Ticket geantwortet",
					buttonsStyling: false,
					customClass: {
						confirmButton: "btn btn-primary"
					}
				}).then(() => {
					// whatever
				})
				
				this.frm.message.value = ""
				this.frm.files.value = []
				this.$emit('reload')
			}
		})
	}
}
